module.exports = __webpack_public_path__ + "static/media/ORDENANZA TRIBUTARIA 639-2024.90f679c2.pdf";